export const DELETE_FILTER = "DELETE_FILTER";
export const DELETE_FILTER_OPEN = "DELETE_FILTER_OPEN";
export const DELETE_POOL = "DELETE_POOL";
export const DELETE_WIKI_OPEN = "DELETE_WIKI_OPEN";
export const SAVE_AUTH_USER_INFO = "SAVE_AUTH_USER_INFO";
export const UPDATE_TOKEN = "UPDATE_TOKEN";
export const SAVE_PASS_STATUS = "SAVE_PASS_STATUS";
export const SAVE_ANALYSES = "SAVE_ANALYSES";
export const SAVE_API_ID = "SAVE_API_ID";
export const SAVE_COLLECTIONS = "SAVE_COLLECTIONS";
export const SAVE_COLLECTION_ID = "SAVE_COLLECTION_ID";
export const SAVE_COLLECTION_DOCS = "SAVE_COLLECTION_DOCS";
export const SAVE_DOCUMENTS = "SAVE_DOCUMENTS";
export const SAVE_EXPORT_DOCUMENTS = "SAVE_EXPORT_DOCUMENTS";
export const SAVE_DOCUMENTS_SELECTION = "SAVE_DOCUMENTS_SELECTION";
export const SAVE_FOCUS_DOCUMENTS = "SAVE_FOCUS_DOCUMENTS";
export const SAVE_FOCUS_DOC_SELECTION = "SAVE_FOCUS_DOC_SELECTION";
export const SAVE_DOCUMENTS_COUNT = "SAVE_DOCUMENTS_COUNT";
export const SAVE_DOCUMENTS_PAGE = "SAVE_DOCUMENTS_PAGE";
export const SAVE_DOCUMENTS_PER_YEAR = "SAVE_DOCUMENTS_PER_YEAR";
export const SAVE_DOCS_PANEL_STATE = "SAVE_DOCS_PANEL_STATE";
export const SAVE_FAVORITES = "SAVE_FAVORITES";
export const SAVE_FILTER_FOCUSED = "SAVE_FILTER_FOCUSED";
export const SAVE_FILTER_DRAGGED = "SAVE_FILTER_DRAGGED";
export const SAVE_FILTERS_TO_EXPORT = "SAVE_FILTERS_TO_EXPORT";
export const SAVE_FILTER_FOCUSED_TYPE = "SAVE_FILTER_FOCUSED_TYPE";
export const SAVE_FILTER_OPEN = "SAVE_FILTER_OPEN";
export const SAVE_FILTER_QUERY = "SAVE_FILTER_QUERY";
export const SAVE_FILTER_ELEMENT = "SAVE_FILTER_ELEMENT";
export const SAVE_FILTERS = "SAVE_FILTERS";
export const SAVE_FILTER_NAMES = "SAVE_FILTER_NAMES";
export const SAVE_FILTERS_INDEX = "SAVE_FILTERS_INDEX";
export const SAVE_DUPLICATE_FILTERS = "SAVE_DUPLICATE_FILTERS";
export const SAVE_IMPORTED_FILTERS = "SAVE_IMPORTED_FILTERS";
export const SAVE_INDICES = "SAVE_INDICES";
export const SAVE_FIELDS = "SAVE_FIELDS";
export const SAVE_DOCUMENTS_DATA = "SAVE_DOCUMENTS_DATA";
export const SAVE_LOADING_STEP = "SAVE_LOADING_STEP";
export const SAVE_METAS = "SAVE_METAS";
export const SAVE_POOLS = "SAVE_POOLS";
export const SAVE_PROJECTS = "SAVE_PROJECTS";
export const SAVE_PROJECT_USERS = "SAVE_PROJECT_USERS";
export const SAVE_SERVER_STATUS = "SAVE_SERVER_STATUS";
export const SAVE_TTC = "SAVE_TTC";
export const SAVE_TTC_COLOR_METRIC = "SAVE_TTC_COLOR_METRIC";
export const SAVE_USERS = "SAVE_USERS";
export const SAVE_WIKI_OPEN = "SAVE_WIKI_OPEN";
export const SAVE_WIKIS = "SAVE_WIKIS";
export const TOGGLE_ADMIN_READY = "TOGGLE_ADMIN_READY";
export const TOGGLE_API_READY = "TOGGLE_API_READY";
export const TOGGLE_API_LOADED = "TOGGLE_API_LOADED";
export const TOGGLE_INSTANCE_READY = "TOGGLE_INSTANCE_READY";
export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const SAVE_MODELS = "SAVE_MODELS";
export const SAVE_FIELD_TABLETOP = "SAVE_FIELD_TABLETOP";
export const SAVE_RING_QUERY = "SAVE_RING_QUERY";
export const SAVE_PLAYER_QUERY = "SAVE_PLAYER_QUERY";
export const SAVE_FIELD_RINGS = "SAVE_FIELD_RINGS";
export const SAVE_VIS_DATA = "SAVE_VIS_DATA";
export const SAVE_SUBSET_FILTER = "SAVE_SUBSET_FILTER";
export const SAVE_ACTIVE_VISUAL = "SAVE_ACTIVE_VISUAL";
export const SAVE_DATA_SETTINGS = "SAVE_DATA_SETTINGS";
export const SAVE_ACTIVE_ELEMENT = "SAVE_ACTIVE_ELEMENT";
export const SAVE_QUERY_VIEW = "SAVE_QUERY_VIEW";
export const SAVE_IMPORT_FILE = "SAVE_IMPORT_FILE";
export const SAVE_REALM_SETTINGS = "SAVE_REALM_SETTINGS";
export const FILTER_SIDEBAR_STATE = "FILTER_SIDEBAR_STATE";
export const FILTER_SIDEBAR_SIZED = "FILTER_SIDEBAR_SIZED";
export const FILTER_BUILDER_TOOLS_STATE = "FILTER_BUILDER_TOOLS_STATE";
export const FILTER_AI_STATE = "FILTER_AI_STATE";
export const FILTER_WIKI_STATE = "FILTER_WIKI_STATE";
export const FILTER_LIST_STATE = "FILTER_LIST_STATE";
export const SAVE_FILTERS_STATE = "SAVE_FILTER_STATE"; 
export const SAVE_FIELDS_STATE = "SAVE_FIELDS_STATE";
export const SAVE_DOCS_STATE = "SAVE_DOCS_STATE";
export const SAVE_DOCSDATA_STATE = "SAVE_DOCSDATA_STATE"; 
export const SAVE_ANALYSIS_STATE = "SAVE_ANALYSIS_STATE";
export const SAVE_FAVOURITES_STATE = "SAVE_FAVOURITES_STATE";
export const SAVE_COLLECTIONS_STATE = "SAVE_COLLECTIONS_STATE";
export const SAVE_TTC_STATE = "SAVE_TTC_STATE";
export const SAVE_REALM_USERS = "SAVE_REALM_USERS";
export const SAVE_REALMS = "SAVE_REALMS";
export const TOGGLE_CHATBOT_STATE = "TOGGLE_CHATBOT_STATE";
export const TOGGLE_CHATBOT_READY = "TOGGLE_CHATBOT_READY";
export const SET_CHATBOT_THREAD = "SET_CHATBOT_THREAD";
export const SOCKET_ONOPEN = "SOCKET_ONOPEN";
export const SOCKET_ONCLOSE = "SOCKET_ONCLOSE";
export const SOCKET_ONERROR = "SOCKET_ONERROR";
export const SOCKET_ONMESSAGE = "SOCKET_ONMESSAGE";
export const SOCKET_RECONNECT = "SOCKET_RECONNECT";
export const SOCKET_RECONNECT_ERROR = "SOCKET_RECONNECT_ERROR";
export const CHANGE_CLASSIFICATION_STATE = "CHANGE_CLASSIFICATION_STATE";
export const CHANGE_CURRENT_STAGE = "CHANGE_CURRENT_STAGE";
export const CHANGE_CLASSIFICATION_PROGRESS = "CHANGE_CLASSIFICATION_PROGRESS";
export const CHANGE_BATCHING_STATUS = "CHANGE_BATCHING_STATUS";
export const SET_NOTIFY_STATUS = "SET_NOTIFY_STATUS";